export default "https://fenwan.cdn.bcebos.com/gamecenter/static/game/assets/imgs/tb-vip-card.8f1d2b47.png";